import {DrawerType} from "../../types/types";
import * as React from "react";
import {useEffect, useState} from "react";
import Drawer from "@mui/material/Drawer";
import RightDrawersHeader from "../../components/utils/RightDrawersHeader";
import NotificationsDrawer from "./rightdrawers/NotificationsDrawer";
import TipsAndTricksDrawer from "./rightdrawers/TipsAndTricksDrawer";
import PersonalSettingsDrawer from "./rightdrawers/PersonalSettingsDrawer";
import AccountSettingsDrawer from "./rightdrawers/AccountSettingsDrawer";
import CloseIcon from "@mui/icons-material/Close";
import styled from "@emotion/styled";

export interface RightDrawersProps {
    drawerType: DrawerType | undefined,
    openDrawer: (type: DrawerType | undefined) => void;
}

const RightDrawers = ({ drawerType, openDrawer } : RightDrawersProps) => {

    const [isOpen, setOpen] = useState(drawerType !== undefined);

    useEffect(() => {
        setOpen(drawerType !== undefined);
    }, [drawerType])

    const toggleDrawer = (open: boolean) =>
        (event: React.KeyboardEvent | React.MouseEvent) => {
            if (
                event.type === 'keydown' &&
                ((event as React.KeyboardEvent).key === 'Tab' ||
                    (event as React.KeyboardEvent).key === 'Shift')
            ) {
                return;
            }

            setOpen(open);
            if (!open) {
                openDrawer(undefined);
            }
        };

    return (
        <React.Fragment>
            <Drawer
                anchor={'right'}
                open={isOpen}
                onClose={toggleDrawer(false)}
            >
                <RightDrawersHeader openDrawer={openDrawer} drawerType={drawerType} />
                <TitleContainer>
                    <Title>
                        {drawerType === DrawerType.NOTIFICATIONS ? "Neuigkeiten" : (
                            drawerType === DrawerType.TIPS_AND_TRICKS ? "Tipps & Tricks" : (
                                drawerType === DrawerType.ACCOUNT_SETTINGS ? "Account Einstellungen" : (
                                    drawerType === DrawerType.PERSONAL_SETTINGS ? "Persönliche Einstellungen" : ""
                                )
                            )
                        )}
                    </Title>
                    <CloseIcon sx={{cursor: 'pointer'}} className="icon" onClick={toggleDrawer(false)}/>
                </TitleContainer>

                {drawerType === DrawerType.NOTIFICATIONS ? <NotificationsDrawer /> : (
                    drawerType === DrawerType.TIPS_AND_TRICKS ? <TipsAndTricksDrawer /> : (
                        drawerType === DrawerType.ACCOUNT_SETTINGS ? <AccountSettingsDrawer /> : (
                            drawerType === DrawerType.PERSONAL_SETTINGS ? <PersonalSettingsDrawer /> : <></>
                        )
                    )
                )}
            </Drawer>
        </React.Fragment>
    );
};

export default RightDrawers;

const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
  margin-left: 24px;
  margin-right: 24px;
  
  .icon {
    fill: #9598A8;
  }
`;

const Title = styled.div`
  color: var(--M3-sys-light-on-surface, #1D1B20);
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 32px;
`;